import { render, staticRenderFns } from "./shuttle_box.vue?vue&type=template&id=08d960a6&scoped=true"
import script from "./shuttle_box.vue?vue&type=script&lang=js"
export * from "./shuttle_box.vue?vue&type=script&lang=js"
import style0 from "./shuttle_box.vue?vue&type=style&index=0&id=08d960a6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d960a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d960a6')) {
      api.createRecord('08d960a6', component.options)
    } else {
      api.reload('08d960a6', component.options)
    }
    module.hot.accept("./shuttle_box.vue?vue&type=template&id=08d960a6&scoped=true", function () {
      api.rerender('08d960a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/contract_template/form/shuttle_box.vue"
export default component.exports